"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ptoConfigUpdateHandler = ptoConfigUpdateHandler;
const errors_1 = __importDefault(require("../js/errors"));
async function ptoConfigUpdateHandler(userId, payload) {
    const requestURL = `/dashboard/${userId}/pto_config`;
    const formData = new URLSearchParams();
    for (const key in payload) {
        const value = payload[key];
        if (value === undefined || value === null)
            return false;
        formData.set(key, value.toString());
    }
    const response = await fetch(requestURL, {
        method: 'POST',
        body: formData,
    });
    const rJson = await response.json();
    if (rJson?.overfillNames && rJson.overfillNames.length) {
        throw new Error(errors_1.default.PTOS.LISTOVERFILLING + rJson.overfillNames.join(', ') + '.');
    }
    return Boolean(rJson?.success);
}
